import { extend, override } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';

export default function () {
  extend(DiscussionHero.prototype, 'items', function (items) {
    if (items.has('title')) {
      items.setPriority('title', 100);
    }
  });
}
